import React, { useState, useEffect } from "react";
import CreateAdminModal from "./CreateAdminModal";
import { useAuth } from "../../src/Context/AuthContext"
import { useNavigate } from 'react-router-dom';

export default function ManageAdminSection() {
    //State Variables
    const [admins, setAdmins] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { logout } = useAuth();
    const navigate = useNavigate();

    //ENV Variables
    const apiURL = import.meta.env.VITE_API;

    useEffect(() => {
        const fetchAdmins = async () => {
            try {
                const res = await fetch(`${apiURL}/admin/search/get-admins`, {
                    method: "GET",
                    credentials: "include"
                });

                if (res.status === 401) {
                    logout();
                    navigate('/login');
                    throw new Error("unauthorized");
                }

                if (res.status === 403) {
                    navigate('/home');
                    throw new Error("forbidden");
                }

                if (!res.ok) {
                    throw new Error("Failed to fetch admins");
                }

                const data = await res.json();
                setAdmins(data);
            } catch (err) {
                console.error(err);
                alert("Error fetching admins");
            }
        };

        fetchAdmins();
    }, []);

    const handleDelete = async (userID) => {
        if (!window.confirm("Are you sure you want to delete this admin?")) return;

        try {
            const res = await fetch(`${apiURL}/admin/delete-Admin?UserID=${userID}`, {
                method: "DELETE",
                credentials: "include"
            });

            if (res.status === 401) {
                logout();
                navigate('/login');
                throw new Error("unauthorized");
            }

            if (res.status === 403) {
                navigate('/home');
                throw new Error("forbidden");
            }

            if (!res.ok) {
                throw new Error("Failed to delete admin");
            }

            setAdmins((prev) => prev.filter((a) => a.userID !== userID));
        } catch (err) {
            console.error(err);
            alert("Error deleting admin");
        }
    };

    const handleAdminCreated = async () => {
            await fetchAdmins();
        setIsModalOpen(false);
    };

    return (
        <div className="manage-admins-container" id="manage-admin-container">
            <div className="header-row">
                <h1 className="page-title"></h1>
                <button className="baseButton" onClick={() => setIsModalOpen(true)}>
                    + Create Admin
                </button>
            </div>

            <div className="admins-grid">
                {admins.length > 0 ? (
                    admins.map((admin) => (
                        <div key={admin.userID} className="admin-card">
                            <div className="admin-card-content">
                                <div>
                                    <p className="admin-name">
                                        {admin.firstName} {admin.lastName}
                                    </p>
                                    <p className="admin-username">{admin.userName}</p>
                                    <p className="admin-email">{admin.email}</p>
                                </div>
                                <button
                                    className="delete-btn"
                                    onClick={() => handleDelete(admin.userID)}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="no-admins-text">No admins found.</p>
                )}
            </div>

            <CreateAdminModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onAdminCreated={handleAdminCreated}
            />
        </div>
    );
}
